import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Layout } from "../../components/layout/Layout";
import { api } from "../../lib/api";
import { Truck, AlertTriangle } from "lucide-react";
import { useAuth, hasPerm } from "../../context/AuthContext";

const STATUS_STYLE = {
  envoyee: "bg-amber-500/15 text-amber-600 border-amber-500/30",
  conforme: "bg-emerald-500/15 text-emerald-600 border-emerald-500/30",
  non_conforme: "bg-red-500/15 text-red-600 border-red-500/30",
  annulee: "bg-slate-500/15 text-slate-500 border-slate-500/30",
};

const STATUS_LABEL = {
  envoyee: "En attente de validation",
  conforme: "Conforme",
  non_conforme: "Non conforme",
  annulee: "Vérification annulée",
};

export default function CommandeListPage() {
  const { user } = useAuth();
  const [commandes, setCommandes] = useState([]);

  useEffect(() => { api.get("/commandes").then((r) => setCommandes(r.data)); }, []);

  if (!(hasPerm(user, "commande", "view") || hasPerm(user, "depot"))) return <Navigate to="/" replace />;

  return (
    <Layout title="Commande">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="commande-list">
        {commandes.length === 0 && <p className="text-muted-foreground">Aucune commande pour le moment.</p>}
        {commandes.map((c) => {
          const hasDepotIssue = c.status === "envoyee" && (c.lines || []).some((l) => l.issue_type);
          return (
            <Link key={c.id} to={`/commandes/${c.id}`} data-testid={`commande-card-${c.id}`} className={`rounded-xl border bg-card p-5 transition-colors duration-200 ${hasDepotIssue ? "border-red-500/40 hover:border-red-500" : "border-border hover:border-primary"}`}>
              <div className="flex items-center justify-between mb-2">
                <p className="font-heading font-semibold flex items-center gap-2"><Truck size={18} />CMD {c.numero}</p>
                <span className={`text-xs px-2 py-1 rounded-md border ${STATUS_STYLE[c.status]}`}>{STATUS_LABEL[c.status]}</span>
              </div>
              <p className="text-sm text-muted-foreground">Boutique : {c.shop_nom}</p>
              <p className="text-xs text-muted-foreground mt-1">{(c.lines || []).length} ligne(s)</p>
              {hasDepotIssue && (
                <p className="text-xs font-medium text-red-600 mt-2 flex items-center gap-1" data-testid={`commande-card-issue-${c.id}`}>
                  <AlertTriangle size={13} /> Produits manquants signalés
                </p>
              )}
            </Link>
          );
        })}
      </div>
    </Layout>
  );
}
